if (!customElements.get('image-with-text-slider')) {
  class ImageWIthTextSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};

      this.autoRotate = Number(this.getAttribute('data-auto-rotate')); // Get the auto-rotate attribute
    }

    // Method to initialize the Swiper slider if present
    initSlider() {
      if (!this.querySelector('[data-slider]')) return; // Exit if no slider element is found

      // Configure Swiper options
      this.options = {
        slidesPerView: 1, // Show as many slides as fit within the container
        loop: true, // Enable infinite scrolling by looping the slides,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      };

      if (this.autoRotate) {
        this.options.autoplay = {
          delay: Number(this.autoRotate)
        }
      }

      // Initialize the Swiper slider
      this.slider = new Swiper(
        this.querySelector('[data-slider]'), // Pass the slider element
        this.options, // Pass the configuration options
      );


      const autoplayButton = this.querySelector('.swiper-autoplay-controller');
      let autoplayState = true;
      autoplayButton.addEventListener('click', (e) => {
        if(!autoplayState) {
          e.target.setAttribute('data-autoplay-state', 'playing')
          autoplayState = true;
          this.slider.slideNext();
          this.slider.autoplay.start();
          this.setAttribute('data-autoplay-state', 'playing');
        } else {
          e.target.setAttribute('data-autoplay-state', 'paused')
          autoplayState = false;
          this.slider.autoplay.stop();
          this.setAttribute('data-autoplay-state', 'paused');
        }
      })
    }

    connectedCallback() {
      this.initSlider(); // Initialize the slider if applicable
    }
  }
  customElements.define('image-with-text-slider', ImageWIthTextSlider);
}